/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as OnboardingRouteRouteImport } from "./routes/onboarding/route"
import { Route as DashboardRouteRouteImport } from "./routes/dashboard/route"
import { Route as AdminRouteRouteImport } from "./routes/admin/route"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as OnboardingIndexRouteImport } from "./routes/onboarding/index"
import { Route as DashboardIndexRouteImport } from "./routes/dashboard/index"
import { Route as AdminIndexRouteImport } from "./routes/admin/index"
import { Route as DashboardShellRouteRouteImport } from "./routes/dashboard/_shell/route"
import { Route as OnboardingCreateSignatureIndexRouteImport } from "./routes/onboarding/create-signature/index"
import { Route as DraftReviewIndexRouteImport } from "./routes/draft/review/index"
import { Route as AdminUsersIndexRouteImport } from "./routes/admin/users/index"
import { Route as AdminSystemTemplatesIndexRouteImport } from "./routes/admin/system-templates/index"
import { Route as AdminPayoutAccessIndexRouteImport } from "./routes/admin/payout-access/index"
import { Route as AdminMetricsIndexRouteImport } from "./routes/admin/metrics/index"
import { Route as AdminInvitesIndexRouteImport } from "./routes/admin/invites/index"
import { Route as AdminFeedbackIndexRouteImport } from "./routes/admin/feedback/index"
import { Route as AdminAccessRequestsIndexRouteImport } from "./routes/admin/access-requests/index"
import { Route as DashboardTemplatesNewIndexRouteImport } from "./routes/dashboard/templates/new/index"
import { Route as DashboardTemplatesTemplateIdIndexRouteImport } from "./routes/dashboard/templates/$templateId/index"
import { Route as DashboardSignatureCreateIndexRouteImport } from "./routes/dashboard/signature/create/index"
import { Route as DashboardEnvelopeCreateIndexRouteImport } from "./routes/dashboard/envelope/create/index"
import { Route as DashboardDocumentSignIndexRouteImport } from "./routes/dashboard/document/sign/index"
import { Route as DashboardShellTemplatesIndexRouteImport } from "./routes/dashboard/_shell/templates/index"
import { Route as DashboardShellSupportIndexRouteImport } from "./routes/dashboard/_shell/support/index"
import { Route as DashboardShellAdminIndexRouteImport } from "./routes/dashboard/_shell/admin/index"
import { Route as AdminSystemTemplatesNewIndexRouteImport } from "./routes/admin/system-templates/new/index"
import { Route as DashboardTemplatesLibrarySystemTemplateIdIndexRouteImport } from "./routes/dashboard/templates/library/$systemTemplateId/index"
import { Route as DashboardTemplatesTemplateIdEditIndexRouteImport } from "./routes/dashboard/templates/$templateId/edit/index"
import { Route as DashboardEnvelopeCreateAddSignIndexRouteImport } from "./routes/dashboard/envelope/create/add-sign/index"
import { Route as DashboardAdminSystemTemplatesNewIndexRouteImport } from "./routes/dashboard/admin/system-templates/new/index"
import { Route as DashboardShellSupportTutorialsIndexRouteImport } from "./routes/dashboard/_shell/support/tutorials/index"
import { Route as DashboardShellSettingsWorkspaceIndexRouteImport } from "./routes/dashboard/_shell/settings/workspace/index"
import { Route as DashboardShellSettingsProfileIndexRouteImport } from "./routes/dashboard/_shell/settings/profile/index"
import { Route as DashboardShellSettingsBillingIndexRouteImport } from "./routes/dashboard/_shell/settings/billing/index"
import { Route as DashboardShellDocumentAllIndexRouteImport } from "./routes/dashboard/_shell/document/all/index"
import { Route as DashboardShellAdminSystemTemplatesIndexRouteImport } from "./routes/dashboard/_shell/admin/system-templates/index"
import { Route as AdminSystemTemplatesSystemTemplateIdEditIndexRouteImport } from "./routes/admin/system-templates/$systemTemplateId/edit/index"
import { Route as DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRouteImport } from "./routes/dashboard/admin/system-templates/$systemTemplateId/edit/index"

const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashboardRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AdminRouteRoute,
} as any)
const DashboardShellRouteRoute = DashboardShellRouteRouteImport.update({
  id: "/_shell",
  getParentRoute: () => DashboardRouteRoute,
} as any)
const OnboardingCreateSignatureIndexRoute =
  OnboardingCreateSignatureIndexRouteImport.update({
    id: "/create-signature/",
    path: "/create-signature/",
    getParentRoute: () => OnboardingRouteRoute,
  } as any)
const DraftReviewIndexRoute = DraftReviewIndexRouteImport.update({
  id: "/draft/review/",
  path: "/draft/review/",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: "/users/",
  path: "/users/",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSystemTemplatesIndexRoute =
  AdminSystemTemplatesIndexRouteImport.update({
    id: "/system-templates/",
    path: "/system-templates/",
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPayoutAccessIndexRoute = AdminPayoutAccessIndexRouteImport.update({
  id: "/payout-access/",
  path: "/payout-access/",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminMetricsIndexRoute = AdminMetricsIndexRouteImport.update({
  id: "/metrics/",
  path: "/metrics/",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminInvitesIndexRoute = AdminInvitesIndexRouteImport.update({
  id: "/invites/",
  path: "/invites/",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFeedbackIndexRoute = AdminFeedbackIndexRouteImport.update({
  id: "/feedback/",
  path: "/feedback/",
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccessRequestsIndexRoute =
  AdminAccessRequestsIndexRouteImport.update({
    id: "/access-requests/",
    path: "/access-requests/",
    getParentRoute: () => AdminRouteRoute,
  } as any)
const DashboardTemplatesNewIndexRoute =
  DashboardTemplatesNewIndexRouteImport.update({
    id: "/templates/new/",
    path: "/templates/new/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTemplatesTemplateIdIndexRoute =
  DashboardTemplatesTemplateIdIndexRouteImport.update({
    id: "/templates/$templateId/",
    path: "/templates/$templateId/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardSignatureCreateIndexRoute =
  DashboardSignatureCreateIndexRouteImport.update({
    id: "/signature/create/",
    path: "/signature/create/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardEnvelopeCreateIndexRoute =
  DashboardEnvelopeCreateIndexRouteImport.update({
    id: "/envelope/create/",
    path: "/envelope/create/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardDocumentSignIndexRoute =
  DashboardDocumentSignIndexRouteImport.update({
    id: "/document/sign/",
    path: "/document/sign/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardShellTemplatesIndexRoute =
  DashboardShellTemplatesIndexRouteImport.update({
    id: "/templates/",
    path: "/templates/",
    getParentRoute: () => DashboardShellRouteRoute,
  } as any)
const DashboardShellSupportIndexRoute =
  DashboardShellSupportIndexRouteImport.update({
    id: "/support/",
    path: "/support/",
    getParentRoute: () => DashboardShellRouteRoute,
  } as any)
const DashboardShellAdminIndexRoute =
  DashboardShellAdminIndexRouteImport.update({
    id: "/admin/",
    path: "/admin/",
    getParentRoute: () => DashboardShellRouteRoute,
  } as any)
const AdminSystemTemplatesNewIndexRoute =
  AdminSystemTemplatesNewIndexRouteImport.update({
    id: "/system-templates/new/",
    path: "/system-templates/new/",
    getParentRoute: () => AdminRouteRoute,
  } as any)
const DashboardTemplatesLibrarySystemTemplateIdIndexRoute =
  DashboardTemplatesLibrarySystemTemplateIdIndexRouteImport.update({
    id: "/templates/library/$systemTemplateId/",
    path: "/templates/library/$systemTemplateId/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTemplatesTemplateIdEditIndexRoute =
  DashboardTemplatesTemplateIdEditIndexRouteImport.update({
    id: "/templates/$templateId/edit/",
    path: "/templates/$templateId/edit/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardEnvelopeCreateAddSignIndexRoute =
  DashboardEnvelopeCreateAddSignIndexRouteImport.update({
    id: "/envelope/create/add-sign/",
    path: "/envelope/create/add-sign/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAdminSystemTemplatesNewIndexRoute =
  DashboardAdminSystemTemplatesNewIndexRouteImport.update({
    id: "/admin/system-templates/new/",
    path: "/admin/system-templates/new/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardShellSupportTutorialsIndexRoute =
  DashboardShellSupportTutorialsIndexRouteImport.update({
    id: "/support/tutorials/",
    path: "/support/tutorials/",
    getParentRoute: () => DashboardShellRouteRoute,
  } as any)
const DashboardShellSettingsWorkspaceIndexRoute =
  DashboardShellSettingsWorkspaceIndexRouteImport.update({
    id: "/settings/workspace/",
    path: "/settings/workspace/",
    getParentRoute: () => DashboardShellRouteRoute,
  } as any)
const DashboardShellSettingsProfileIndexRoute =
  DashboardShellSettingsProfileIndexRouteImport.update({
    id: "/settings/profile/",
    path: "/settings/profile/",
    getParentRoute: () => DashboardShellRouteRoute,
  } as any)
const DashboardShellSettingsBillingIndexRoute =
  DashboardShellSettingsBillingIndexRouteImport.update({
    id: "/settings/billing/",
    path: "/settings/billing/",
    getParentRoute: () => DashboardShellRouteRoute,
  } as any)
const DashboardShellDocumentAllIndexRoute =
  DashboardShellDocumentAllIndexRouteImport.update({
    id: "/document/all/",
    path: "/document/all/",
    getParentRoute: () => DashboardShellRouteRoute,
  } as any)
const DashboardShellAdminSystemTemplatesIndexRoute =
  DashboardShellAdminSystemTemplatesIndexRouteImport.update({
    id: "/admin/system-templates/",
    path: "/admin/system-templates/",
    getParentRoute: () => DashboardShellRouteRoute,
  } as any)
const AdminSystemTemplatesSystemTemplateIdEditIndexRoute =
  AdminSystemTemplatesSystemTemplateIdEditIndexRouteImport.update({
    id: "/system-templates/$systemTemplateId/edit/",
    path: "/system-templates/$systemTemplateId/edit/",
    getParentRoute: () => AdminRouteRoute,
  } as any)
const DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRoute =
  DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRouteImport.update({
    id: "/admin/system-templates/$systemTemplateId/edit/",
    path: "/admin/system-templates/$systemTemplateId/edit/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/admin": typeof AdminRouteRouteWithChildren
  "/dashboard": typeof DashboardShellRouteRouteWithChildren
  "/onboarding": typeof OnboardingRouteRouteWithChildren
  "/admin/": typeof AdminIndexRoute
  "/dashboard/": typeof DashboardIndexRoute
  "/onboarding/": typeof OnboardingIndexRoute
  "/admin/access-requests/": typeof AdminAccessRequestsIndexRoute
  "/admin/feedback/": typeof AdminFeedbackIndexRoute
  "/admin/invites/": typeof AdminInvitesIndexRoute
  "/admin/metrics/": typeof AdminMetricsIndexRoute
  "/admin/payout-access/": typeof AdminPayoutAccessIndexRoute
  "/admin/system-templates/": typeof AdminSystemTemplatesIndexRoute
  "/admin/users/": typeof AdminUsersIndexRoute
  "/draft/review/": typeof DraftReviewIndexRoute
  "/onboarding/create-signature/": typeof OnboardingCreateSignatureIndexRoute
  "/admin/system-templates/new/": typeof AdminSystemTemplatesNewIndexRoute
  "/dashboard/admin/": typeof DashboardShellAdminIndexRoute
  "/dashboard/support/": typeof DashboardShellSupportIndexRoute
  "/dashboard/templates/": typeof DashboardShellTemplatesIndexRoute
  "/dashboard/document/sign/": typeof DashboardDocumentSignIndexRoute
  "/dashboard/envelope/create/": typeof DashboardEnvelopeCreateIndexRoute
  "/dashboard/signature/create/": typeof DashboardSignatureCreateIndexRoute
  "/dashboard/templates/$templateId/": typeof DashboardTemplatesTemplateIdIndexRoute
  "/dashboard/templates/new/": typeof DashboardTemplatesNewIndexRoute
  "/admin/system-templates/$systemTemplateId/edit/": typeof AdminSystemTemplatesSystemTemplateIdEditIndexRoute
  "/dashboard/admin/system-templates/": typeof DashboardShellAdminSystemTemplatesIndexRoute
  "/dashboard/document/all/": typeof DashboardShellDocumentAllIndexRoute
  "/dashboard/settings/billing/": typeof DashboardShellSettingsBillingIndexRoute
  "/dashboard/settings/profile/": typeof DashboardShellSettingsProfileIndexRoute
  "/dashboard/settings/workspace/": typeof DashboardShellSettingsWorkspaceIndexRoute
  "/dashboard/support/tutorials/": typeof DashboardShellSupportTutorialsIndexRoute
  "/dashboard/admin/system-templates/new/": typeof DashboardAdminSystemTemplatesNewIndexRoute
  "/dashboard/envelope/create/add-sign/": typeof DashboardEnvelopeCreateAddSignIndexRoute
  "/dashboard/templates/$templateId/edit/": typeof DashboardTemplatesTemplateIdEditIndexRoute
  "/dashboard/templates/library/$systemTemplateId/": typeof DashboardTemplatesLibrarySystemTemplateIdIndexRoute
  "/dashboard/admin/system-templates/$systemTemplateId/edit/": typeof DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/dashboard": typeof DashboardIndexRoute
  "/admin": typeof AdminIndexRoute
  "/onboarding": typeof OnboardingIndexRoute
  "/admin/access-requests": typeof AdminAccessRequestsIndexRoute
  "/admin/feedback": typeof AdminFeedbackIndexRoute
  "/admin/invites": typeof AdminInvitesIndexRoute
  "/admin/metrics": typeof AdminMetricsIndexRoute
  "/admin/payout-access": typeof AdminPayoutAccessIndexRoute
  "/admin/system-templates": typeof AdminSystemTemplatesIndexRoute
  "/admin/users": typeof AdminUsersIndexRoute
  "/draft/review": typeof DraftReviewIndexRoute
  "/onboarding/create-signature": typeof OnboardingCreateSignatureIndexRoute
  "/admin/system-templates/new": typeof AdminSystemTemplatesNewIndexRoute
  "/dashboard/admin": typeof DashboardShellAdminIndexRoute
  "/dashboard/support": typeof DashboardShellSupportIndexRoute
  "/dashboard/templates": typeof DashboardShellTemplatesIndexRoute
  "/dashboard/document/sign": typeof DashboardDocumentSignIndexRoute
  "/dashboard/envelope/create": typeof DashboardEnvelopeCreateIndexRoute
  "/dashboard/signature/create": typeof DashboardSignatureCreateIndexRoute
  "/dashboard/templates/$templateId": typeof DashboardTemplatesTemplateIdIndexRoute
  "/dashboard/templates/new": typeof DashboardTemplatesNewIndexRoute
  "/admin/system-templates/$systemTemplateId/edit": typeof AdminSystemTemplatesSystemTemplateIdEditIndexRoute
  "/dashboard/admin/system-templates": typeof DashboardShellAdminSystemTemplatesIndexRoute
  "/dashboard/document/all": typeof DashboardShellDocumentAllIndexRoute
  "/dashboard/settings/billing": typeof DashboardShellSettingsBillingIndexRoute
  "/dashboard/settings/profile": typeof DashboardShellSettingsProfileIndexRoute
  "/dashboard/settings/workspace": typeof DashboardShellSettingsWorkspaceIndexRoute
  "/dashboard/support/tutorials": typeof DashboardShellSupportTutorialsIndexRoute
  "/dashboard/admin/system-templates/new": typeof DashboardAdminSystemTemplatesNewIndexRoute
  "/dashboard/envelope/create/add-sign": typeof DashboardEnvelopeCreateAddSignIndexRoute
  "/dashboard/templates/$templateId/edit": typeof DashboardTemplatesTemplateIdEditIndexRoute
  "/dashboard/templates/library/$systemTemplateId": typeof DashboardTemplatesLibrarySystemTemplateIdIndexRoute
  "/dashboard/admin/system-templates/$systemTemplateId/edit": typeof DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/admin": typeof AdminRouteRouteWithChildren
  "/dashboard": typeof DashboardRouteRouteWithChildren
  "/onboarding": typeof OnboardingRouteRouteWithChildren
  "/dashboard/_shell": typeof DashboardShellRouteRouteWithChildren
  "/admin/": typeof AdminIndexRoute
  "/dashboard/": typeof DashboardIndexRoute
  "/onboarding/": typeof OnboardingIndexRoute
  "/admin/access-requests/": typeof AdminAccessRequestsIndexRoute
  "/admin/feedback/": typeof AdminFeedbackIndexRoute
  "/admin/invites/": typeof AdminInvitesIndexRoute
  "/admin/metrics/": typeof AdminMetricsIndexRoute
  "/admin/payout-access/": typeof AdminPayoutAccessIndexRoute
  "/admin/system-templates/": typeof AdminSystemTemplatesIndexRoute
  "/admin/users/": typeof AdminUsersIndexRoute
  "/draft/review/": typeof DraftReviewIndexRoute
  "/onboarding/create-signature/": typeof OnboardingCreateSignatureIndexRoute
  "/admin/system-templates/new/": typeof AdminSystemTemplatesNewIndexRoute
  "/dashboard/_shell/admin/": typeof DashboardShellAdminIndexRoute
  "/dashboard/_shell/support/": typeof DashboardShellSupportIndexRoute
  "/dashboard/_shell/templates/": typeof DashboardShellTemplatesIndexRoute
  "/dashboard/document/sign/": typeof DashboardDocumentSignIndexRoute
  "/dashboard/envelope/create/": typeof DashboardEnvelopeCreateIndexRoute
  "/dashboard/signature/create/": typeof DashboardSignatureCreateIndexRoute
  "/dashboard/templates/$templateId/": typeof DashboardTemplatesTemplateIdIndexRoute
  "/dashboard/templates/new/": typeof DashboardTemplatesNewIndexRoute
  "/admin/system-templates/$systemTemplateId/edit/": typeof AdminSystemTemplatesSystemTemplateIdEditIndexRoute
  "/dashboard/_shell/admin/system-templates/": typeof DashboardShellAdminSystemTemplatesIndexRoute
  "/dashboard/_shell/document/all/": typeof DashboardShellDocumentAllIndexRoute
  "/dashboard/_shell/settings/billing/": typeof DashboardShellSettingsBillingIndexRoute
  "/dashboard/_shell/settings/profile/": typeof DashboardShellSettingsProfileIndexRoute
  "/dashboard/_shell/settings/workspace/": typeof DashboardShellSettingsWorkspaceIndexRoute
  "/dashboard/_shell/support/tutorials/": typeof DashboardShellSupportTutorialsIndexRoute
  "/dashboard/admin/system-templates/new/": typeof DashboardAdminSystemTemplatesNewIndexRoute
  "/dashboard/envelope/create/add-sign/": typeof DashboardEnvelopeCreateAddSignIndexRoute
  "/dashboard/templates/$templateId/edit/": typeof DashboardTemplatesTemplateIdEditIndexRoute
  "/dashboard/templates/library/$systemTemplateId/": typeof DashboardTemplatesLibrarySystemTemplateIdIndexRoute
  "/dashboard/admin/system-templates/$systemTemplateId/edit/": typeof DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/admin"
    | "/dashboard"
    | "/onboarding"
    | "/admin/"
    | "/dashboard/"
    | "/onboarding/"
    | "/admin/access-requests/"
    | "/admin/feedback/"
    | "/admin/invites/"
    | "/admin/metrics/"
    | "/admin/payout-access/"
    | "/admin/system-templates/"
    | "/admin/users/"
    | "/draft/review/"
    | "/onboarding/create-signature/"
    | "/admin/system-templates/new/"
    | "/dashboard/admin/"
    | "/dashboard/support/"
    | "/dashboard/templates/"
    | "/dashboard/document/sign/"
    | "/dashboard/envelope/create/"
    | "/dashboard/signature/create/"
    | "/dashboard/templates/$templateId/"
    | "/dashboard/templates/new/"
    | "/admin/system-templates/$systemTemplateId/edit/"
    | "/dashboard/admin/system-templates/"
    | "/dashboard/document/all/"
    | "/dashboard/settings/billing/"
    | "/dashboard/settings/profile/"
    | "/dashboard/settings/workspace/"
    | "/dashboard/support/tutorials/"
    | "/dashboard/admin/system-templates/new/"
    | "/dashboard/envelope/create/add-sign/"
    | "/dashboard/templates/$templateId/edit/"
    | "/dashboard/templates/library/$systemTemplateId/"
    | "/dashboard/admin/system-templates/$systemTemplateId/edit/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/dashboard"
    | "/admin"
    | "/onboarding"
    | "/admin/access-requests"
    | "/admin/feedback"
    | "/admin/invites"
    | "/admin/metrics"
    | "/admin/payout-access"
    | "/admin/system-templates"
    | "/admin/users"
    | "/draft/review"
    | "/onboarding/create-signature"
    | "/admin/system-templates/new"
    | "/dashboard/admin"
    | "/dashboard/support"
    | "/dashboard/templates"
    | "/dashboard/document/sign"
    | "/dashboard/envelope/create"
    | "/dashboard/signature/create"
    | "/dashboard/templates/$templateId"
    | "/dashboard/templates/new"
    | "/admin/system-templates/$systemTemplateId/edit"
    | "/dashboard/admin/system-templates"
    | "/dashboard/document/all"
    | "/dashboard/settings/billing"
    | "/dashboard/settings/profile"
    | "/dashboard/settings/workspace"
    | "/dashboard/support/tutorials"
    | "/dashboard/admin/system-templates/new"
    | "/dashboard/envelope/create/add-sign"
    | "/dashboard/templates/$templateId/edit"
    | "/dashboard/templates/library/$systemTemplateId"
    | "/dashboard/admin/system-templates/$systemTemplateId/edit"
  id:
    | "__root__"
    | "/"
    | "/admin"
    | "/dashboard"
    | "/onboarding"
    | "/dashboard/_shell"
    | "/admin/"
    | "/dashboard/"
    | "/onboarding/"
    | "/admin/access-requests/"
    | "/admin/feedback/"
    | "/admin/invites/"
    | "/admin/metrics/"
    | "/admin/payout-access/"
    | "/admin/system-templates/"
    | "/admin/users/"
    | "/draft/review/"
    | "/onboarding/create-signature/"
    | "/admin/system-templates/new/"
    | "/dashboard/_shell/admin/"
    | "/dashboard/_shell/support/"
    | "/dashboard/_shell/templates/"
    | "/dashboard/document/sign/"
    | "/dashboard/envelope/create/"
    | "/dashboard/signature/create/"
    | "/dashboard/templates/$templateId/"
    | "/dashboard/templates/new/"
    | "/admin/system-templates/$systemTemplateId/edit/"
    | "/dashboard/_shell/admin/system-templates/"
    | "/dashboard/_shell/document/all/"
    | "/dashboard/_shell/settings/billing/"
    | "/dashboard/_shell/settings/profile/"
    | "/dashboard/_shell/settings/workspace/"
    | "/dashboard/_shell/support/tutorials/"
    | "/dashboard/admin/system-templates/new/"
    | "/dashboard/envelope/create/add-sign/"
    | "/dashboard/templates/$templateId/edit/"
    | "/dashboard/templates/library/$systemTemplateId/"
    | "/dashboard/admin/system-templates/$systemTemplateId/edit/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  DraftReviewIndexRoute: typeof DraftReviewIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/onboarding": {
      id: "/onboarding"
      path: "/onboarding"
      fullPath: "/onboarding"
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dashboard": {
      id: "/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin": {
      id: "/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/onboarding/": {
      id: "/onboarding/"
      path: "/"
      fullPath: "/onboarding/"
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    "/dashboard/": {
      id: "/dashboard/"
      path: "/"
      fullPath: "/dashboard/"
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/admin/": {
      id: "/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/dashboard/_shell": {
      id: "/dashboard/_shell"
      path: ""
      fullPath: "/dashboard"
      preLoaderRoute: typeof DashboardShellRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/onboarding/create-signature/": {
      id: "/onboarding/create-signature/"
      path: "/create-signature"
      fullPath: "/onboarding/create-signature/"
      preLoaderRoute: typeof OnboardingCreateSignatureIndexRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    "/draft/review/": {
      id: "/draft/review/"
      path: "/draft/review"
      fullPath: "/draft/review/"
      preLoaderRoute: typeof DraftReviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/users/": {
      id: "/admin/users/"
      path: "/users"
      fullPath: "/admin/users/"
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/system-templates/": {
      id: "/admin/system-templates/"
      path: "/system-templates"
      fullPath: "/admin/system-templates/"
      preLoaderRoute: typeof AdminSystemTemplatesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/payout-access/": {
      id: "/admin/payout-access/"
      path: "/payout-access"
      fullPath: "/admin/payout-access/"
      preLoaderRoute: typeof AdminPayoutAccessIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/metrics/": {
      id: "/admin/metrics/"
      path: "/metrics"
      fullPath: "/admin/metrics/"
      preLoaderRoute: typeof AdminMetricsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/invites/": {
      id: "/admin/invites/"
      path: "/invites"
      fullPath: "/admin/invites/"
      preLoaderRoute: typeof AdminInvitesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/feedback/": {
      id: "/admin/feedback/"
      path: "/feedback"
      fullPath: "/admin/feedback/"
      preLoaderRoute: typeof AdminFeedbackIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/admin/access-requests/": {
      id: "/admin/access-requests/"
      path: "/access-requests"
      fullPath: "/admin/access-requests/"
      preLoaderRoute: typeof AdminAccessRequestsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/dashboard/templates/new/": {
      id: "/dashboard/templates/new/"
      path: "/templates/new"
      fullPath: "/dashboard/templates/new/"
      preLoaderRoute: typeof DashboardTemplatesNewIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/dashboard/templates/$templateId/": {
      id: "/dashboard/templates/$templateId/"
      path: "/templates/$templateId"
      fullPath: "/dashboard/templates/$templateId/"
      preLoaderRoute: typeof DashboardTemplatesTemplateIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/dashboard/signature/create/": {
      id: "/dashboard/signature/create/"
      path: "/signature/create"
      fullPath: "/dashboard/signature/create/"
      preLoaderRoute: typeof DashboardSignatureCreateIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/dashboard/envelope/create/": {
      id: "/dashboard/envelope/create/"
      path: "/envelope/create"
      fullPath: "/dashboard/envelope/create/"
      preLoaderRoute: typeof DashboardEnvelopeCreateIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/dashboard/document/sign/": {
      id: "/dashboard/document/sign/"
      path: "/document/sign"
      fullPath: "/dashboard/document/sign/"
      preLoaderRoute: typeof DashboardDocumentSignIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/dashboard/_shell/templates/": {
      id: "/dashboard/_shell/templates/"
      path: "/templates"
      fullPath: "/dashboard/templates/"
      preLoaderRoute: typeof DashboardShellTemplatesIndexRouteImport
      parentRoute: typeof DashboardShellRouteRoute
    }
    "/dashboard/_shell/support/": {
      id: "/dashboard/_shell/support/"
      path: "/support"
      fullPath: "/dashboard/support/"
      preLoaderRoute: typeof DashboardShellSupportIndexRouteImport
      parentRoute: typeof DashboardShellRouteRoute
    }
    "/dashboard/_shell/admin/": {
      id: "/dashboard/_shell/admin/"
      path: "/admin"
      fullPath: "/dashboard/admin/"
      preLoaderRoute: typeof DashboardShellAdminIndexRouteImport
      parentRoute: typeof DashboardShellRouteRoute
    }
    "/admin/system-templates/new/": {
      id: "/admin/system-templates/new/"
      path: "/system-templates/new"
      fullPath: "/admin/system-templates/new/"
      preLoaderRoute: typeof AdminSystemTemplatesNewIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/dashboard/templates/library/$systemTemplateId/": {
      id: "/dashboard/templates/library/$systemTemplateId/"
      path: "/templates/library/$systemTemplateId"
      fullPath: "/dashboard/templates/library/$systemTemplateId/"
      preLoaderRoute: typeof DashboardTemplatesLibrarySystemTemplateIdIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/dashboard/templates/$templateId/edit/": {
      id: "/dashboard/templates/$templateId/edit/"
      path: "/templates/$templateId/edit"
      fullPath: "/dashboard/templates/$templateId/edit/"
      preLoaderRoute: typeof DashboardTemplatesTemplateIdEditIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/dashboard/envelope/create/add-sign/": {
      id: "/dashboard/envelope/create/add-sign/"
      path: "/envelope/create/add-sign"
      fullPath: "/dashboard/envelope/create/add-sign/"
      preLoaderRoute: typeof DashboardEnvelopeCreateAddSignIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/dashboard/admin/system-templates/new/": {
      id: "/dashboard/admin/system-templates/new/"
      path: "/admin/system-templates/new"
      fullPath: "/dashboard/admin/system-templates/new/"
      preLoaderRoute: typeof DashboardAdminSystemTemplatesNewIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/dashboard/_shell/support/tutorials/": {
      id: "/dashboard/_shell/support/tutorials/"
      path: "/support/tutorials"
      fullPath: "/dashboard/support/tutorials/"
      preLoaderRoute: typeof DashboardShellSupportTutorialsIndexRouteImport
      parentRoute: typeof DashboardShellRouteRoute
    }
    "/dashboard/_shell/settings/workspace/": {
      id: "/dashboard/_shell/settings/workspace/"
      path: "/settings/workspace"
      fullPath: "/dashboard/settings/workspace/"
      preLoaderRoute: typeof DashboardShellSettingsWorkspaceIndexRouteImport
      parentRoute: typeof DashboardShellRouteRoute
    }
    "/dashboard/_shell/settings/profile/": {
      id: "/dashboard/_shell/settings/profile/"
      path: "/settings/profile"
      fullPath: "/dashboard/settings/profile/"
      preLoaderRoute: typeof DashboardShellSettingsProfileIndexRouteImport
      parentRoute: typeof DashboardShellRouteRoute
    }
    "/dashboard/_shell/settings/billing/": {
      id: "/dashboard/_shell/settings/billing/"
      path: "/settings/billing"
      fullPath: "/dashboard/settings/billing/"
      preLoaderRoute: typeof DashboardShellSettingsBillingIndexRouteImport
      parentRoute: typeof DashboardShellRouteRoute
    }
    "/dashboard/_shell/document/all/": {
      id: "/dashboard/_shell/document/all/"
      path: "/document/all"
      fullPath: "/dashboard/document/all/"
      preLoaderRoute: typeof DashboardShellDocumentAllIndexRouteImport
      parentRoute: typeof DashboardShellRouteRoute
    }
    "/dashboard/_shell/admin/system-templates/": {
      id: "/dashboard/_shell/admin/system-templates/"
      path: "/admin/system-templates"
      fullPath: "/dashboard/admin/system-templates/"
      preLoaderRoute: typeof DashboardShellAdminSystemTemplatesIndexRouteImport
      parentRoute: typeof DashboardShellRouteRoute
    }
    "/admin/system-templates/$systemTemplateId/edit/": {
      id: "/admin/system-templates/$systemTemplateId/edit/"
      path: "/system-templates/$systemTemplateId/edit"
      fullPath: "/admin/system-templates/$systemTemplateId/edit/"
      preLoaderRoute: typeof AdminSystemTemplatesSystemTemplateIdEditIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    "/dashboard/admin/system-templates/$systemTemplateId/edit/": {
      id: "/dashboard/admin/system-templates/$systemTemplateId/edit/"
      path: "/admin/system-templates/$systemTemplateId/edit"
      fullPath: "/dashboard/admin/system-templates/$systemTemplateId/edit/"
      preLoaderRoute: typeof DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminAccessRequestsIndexRoute: typeof AdminAccessRequestsIndexRoute
  AdminFeedbackIndexRoute: typeof AdminFeedbackIndexRoute
  AdminInvitesIndexRoute: typeof AdminInvitesIndexRoute
  AdminMetricsIndexRoute: typeof AdminMetricsIndexRoute
  AdminPayoutAccessIndexRoute: typeof AdminPayoutAccessIndexRoute
  AdminSystemTemplatesIndexRoute: typeof AdminSystemTemplatesIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminSystemTemplatesNewIndexRoute: typeof AdminSystemTemplatesNewIndexRoute
  AdminSystemTemplatesSystemTemplateIdEditIndexRoute: typeof AdminSystemTemplatesSystemTemplateIdEditIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminAccessRequestsIndexRoute: AdminAccessRequestsIndexRoute,
  AdminFeedbackIndexRoute: AdminFeedbackIndexRoute,
  AdminInvitesIndexRoute: AdminInvitesIndexRoute,
  AdminMetricsIndexRoute: AdminMetricsIndexRoute,
  AdminPayoutAccessIndexRoute: AdminPayoutAccessIndexRoute,
  AdminSystemTemplatesIndexRoute: AdminSystemTemplatesIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminSystemTemplatesNewIndexRoute: AdminSystemTemplatesNewIndexRoute,
  AdminSystemTemplatesSystemTemplateIdEditIndexRoute:
    AdminSystemTemplatesSystemTemplateIdEditIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface DashboardShellRouteRouteChildren {
  DashboardShellAdminIndexRoute: typeof DashboardShellAdminIndexRoute
  DashboardShellSupportIndexRoute: typeof DashboardShellSupportIndexRoute
  DashboardShellTemplatesIndexRoute: typeof DashboardShellTemplatesIndexRoute
  DashboardShellAdminSystemTemplatesIndexRoute: typeof DashboardShellAdminSystemTemplatesIndexRoute
  DashboardShellDocumentAllIndexRoute: typeof DashboardShellDocumentAllIndexRoute
  DashboardShellSettingsBillingIndexRoute: typeof DashboardShellSettingsBillingIndexRoute
  DashboardShellSettingsProfileIndexRoute: typeof DashboardShellSettingsProfileIndexRoute
  DashboardShellSettingsWorkspaceIndexRoute: typeof DashboardShellSettingsWorkspaceIndexRoute
  DashboardShellSupportTutorialsIndexRoute: typeof DashboardShellSupportTutorialsIndexRoute
}

const DashboardShellRouteRouteChildren: DashboardShellRouteRouteChildren = {
  DashboardShellAdminIndexRoute: DashboardShellAdminIndexRoute,
  DashboardShellSupportIndexRoute: DashboardShellSupportIndexRoute,
  DashboardShellTemplatesIndexRoute: DashboardShellTemplatesIndexRoute,
  DashboardShellAdminSystemTemplatesIndexRoute:
    DashboardShellAdminSystemTemplatesIndexRoute,
  DashboardShellDocumentAllIndexRoute: DashboardShellDocumentAllIndexRoute,
  DashboardShellSettingsBillingIndexRoute:
    DashboardShellSettingsBillingIndexRoute,
  DashboardShellSettingsProfileIndexRoute:
    DashboardShellSettingsProfileIndexRoute,
  DashboardShellSettingsWorkspaceIndexRoute:
    DashboardShellSettingsWorkspaceIndexRoute,
  DashboardShellSupportTutorialsIndexRoute:
    DashboardShellSupportTutorialsIndexRoute,
}

const DashboardShellRouteRouteWithChildren =
  DashboardShellRouteRoute._addFileChildren(DashboardShellRouteRouteChildren)

interface DashboardRouteRouteChildren {
  DashboardShellRouteRoute: typeof DashboardShellRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardDocumentSignIndexRoute: typeof DashboardDocumentSignIndexRoute
  DashboardEnvelopeCreateIndexRoute: typeof DashboardEnvelopeCreateIndexRoute
  DashboardSignatureCreateIndexRoute: typeof DashboardSignatureCreateIndexRoute
  DashboardTemplatesTemplateIdIndexRoute: typeof DashboardTemplatesTemplateIdIndexRoute
  DashboardTemplatesNewIndexRoute: typeof DashboardTemplatesNewIndexRoute
  DashboardAdminSystemTemplatesNewIndexRoute: typeof DashboardAdminSystemTemplatesNewIndexRoute
  DashboardEnvelopeCreateAddSignIndexRoute: typeof DashboardEnvelopeCreateAddSignIndexRoute
  DashboardTemplatesTemplateIdEditIndexRoute: typeof DashboardTemplatesTemplateIdEditIndexRoute
  DashboardTemplatesLibrarySystemTemplateIdIndexRoute: typeof DashboardTemplatesLibrarySystemTemplateIdIndexRoute
  DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRoute: typeof DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardShellRouteRoute: DashboardShellRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardDocumentSignIndexRoute: DashboardDocumentSignIndexRoute,
  DashboardEnvelopeCreateIndexRoute: DashboardEnvelopeCreateIndexRoute,
  DashboardSignatureCreateIndexRoute: DashboardSignatureCreateIndexRoute,
  DashboardTemplatesTemplateIdIndexRoute:
    DashboardTemplatesTemplateIdIndexRoute,
  DashboardTemplatesNewIndexRoute: DashboardTemplatesNewIndexRoute,
  DashboardAdminSystemTemplatesNewIndexRoute:
    DashboardAdminSystemTemplatesNewIndexRoute,
  DashboardEnvelopeCreateAddSignIndexRoute:
    DashboardEnvelopeCreateAddSignIndexRoute,
  DashboardTemplatesTemplateIdEditIndexRoute:
    DashboardTemplatesTemplateIdEditIndexRoute,
  DashboardTemplatesLibrarySystemTemplateIdIndexRoute:
    DashboardTemplatesLibrarySystemTemplateIdIndexRoute,
  DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRoute:
    DashboardAdminSystemTemplatesSystemTemplateIdEditIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface OnboardingRouteRouteChildren {
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  OnboardingCreateSignatureIndexRoute: typeof OnboardingCreateSignatureIndexRoute
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingIndexRoute: OnboardingIndexRoute,
  OnboardingCreateSignatureIndexRoute: OnboardingCreateSignatureIndexRoute,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  DraftReviewIndexRoute: DraftReviewIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
